module.exports = {"pathContext":{"name":"WeightUnit","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"G"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"KG"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"LB"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"M2"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-weight-unit.json
// module id = 905
// module chunks = 75065823977230